import { render, staticRenderFns } from "./DataDictionary.vue?vue&type=template&id=46d6bf7f&scoped=true"
import script from "./DataDictionary.vue?vue&type=script&lang=js"
export * from "./DataDictionary.vue?vue&type=script&lang=js"
import style0 from "./DataDictionary.vue?vue&type=style&index=0&id=46d6bf7f&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46d6bf7f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\web\\medical\\medical-student\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('46d6bf7f')) {
      api.createRecord('46d6bf7f', component.options)
    } else {
      api.reload('46d6bf7f', component.options)
    }
    module.hot.accept("./DataDictionary.vue?vue&type=template&id=46d6bf7f&scoped=true", function () {
      api.rerender('46d6bf7f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/manage/dataDictionary/DataDictionary.vue"
export default component.exports